import React from 'react';
import { terms } from '../styles';

const PrivacyTerms = () => {
  return (
    <div style={terms}>
      <p>
        By continuing, you may receive an SMS for verification. Message and data
        rates may apply.
      </p>
      <p>
        By creating an account, you consent to the terms outlined in the{' '}
        <a target="_blank" href="/terms">
          Privacy & Terms
        </a>
        .
      </p>
    </div>
  );
};

export default PrivacyTerms;
